import styled from 'styled-components';

export const MaginLeft = styled.div`
	margin-left: 30px;
`;

export const Container = styled.div`
	position: relative;
`;

export const DateContainer = styled.div`
	background: #fff;
	border-radius: 20px;
	padding: 4px 6px;
	max-height: 32px;
	box-sizing: border-box;
	height: 32px;
	cursor: pointer;
`;

export const Image = styled.img<{ height?: string }>`
	height: ${props => props.height || 'initial'};
`;
